import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import {
  LEAD_NOTIFICATION_STATUS,
  LeadNotificationStatus,
} from 'models/LeadNotifications';
import EyeIcon from 'icons/Eye.icon';
import CircledExclamationmarkIcon from 'icons/CircledExclamationmark.icon';
import CheckcircleIcon from 'icons/Checkcircle.icon';
import { COLOR_VARIANT } from 'models/Colors';

import './NotificationStatusTag.styles.scss';

const LABEL = {
  [LEAD_NOTIFICATION_STATUS.FAILED]: 'failed',
  [LEAD_NOTIFICATION_STATUS.RECEIVED]: 'delivered',
  [LEAD_NOTIFICATION_STATUS.OPENED]: 'opened',
};

const ICON = {
  [LEAD_NOTIFICATION_STATUS.FAILED]: CircledExclamationmarkIcon,
  [LEAD_NOTIFICATION_STATUS.RECEIVED]: CheckcircleIcon,
  [LEAD_NOTIFICATION_STATUS.OPENED]: EyeIcon,
};

const COLOR = {
  [LEAD_NOTIFICATION_STATUS.FAILED]: COLOR_VARIANT.RED,
  [LEAD_NOTIFICATION_STATUS.RECEIVED]: COLOR_VARIANT.GREEN,
  [LEAD_NOTIFICATION_STATUS.OPENED]: COLOR_VARIANT.BLUE,
};

type NotificationStatusTagProps = {
  className?: string;
  status: LeadNotificationStatus;
};

const NotificationStatusTag: React.FC<NotificationStatusTagProps> = (props) => {
  const { className, status } = props;

  const classes = classNames(
    'notification-status-tag',
    COLOR[status],
    className,
  );

  const { t } = useTranslation();

  const Icon = ICON[status];
  const label = t(LABEL[status]);

  return (
    <span className={classes}>
      <Icon />
      <span>{label}</span>
    </span>
  );
};

export default NotificationStatusTag;
